// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__19ojf","info":"PatientInfo_info__2ukMA"};